import axios from './HTTP'

export default {
  get (callback, errorCallback) {
    axios
      .get(`/api/profile.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },

  getUserID (userID, callback, errorCallback) {
    axios
      .get(`/api/profiles/${ userID }.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },

  update (params, callback, errorCallback) {
    axios
      .patch(`/api/profile.json`, params)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },

  clientUpdate (params, callback, errorCallback) {
    axios
      .patch(`/api/client_own_profile.json`, {
        own_profile: params
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },

  employeeUpdate (params, callback, errorCallback) {
    axios
      .patch(`/api/employee_own_profile.json`, {
        own_profile: params
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },

  managerUpdate (params, callback, errorCallback) {
    axios
      .patch(`/api/manager_own_profile.json`, {
        own_profile: params
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },

  saveFilterSet(params, callback, errorCallback) {
    axios
      .post(`/api/filter_presets.json`, {
        filter_preset: params
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },
  deleteFilterSet(presetID, callback, errorCallback) {
    axios
      .delete(`/api/filter_presets/${ presetID }.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  },
  getFilterSets(params, callback, errorCallback) {
    axios
      .get(`/api/filter_presets.json`, {
        params
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(errorCallback) ))
  }
}
